<template>
  <div>
    <div>
      <div class="columns">
        <div class="column is-12">
          <div class="field">
            <label class="label">Contact Number<b-icon pack="fas" icon="star" class="fa-ss"></b-icon><a class="is-pulled-right" @click="onRemoveContactNumberConfirm"><i class="has-text-danger fas fa-trash fa-sm"></i></a></label>
            <div class="field is-grouped is-align-items-flex-end">
              <div class="control is-expanded">
                <input v-validate="{'min': 16, 'max': 16, 'required': isRequired, 'contact_number_unique': isUniqueNumber}" :name="instanceName + '.contactNumber'" :data-vv-scope="scope" data-vv-as="contact number" :class="{'input': true }" type="text" placeholder="+1(999)-999-9999" v-mask="'+1(###)-###-####'" v-model="customerContactNumber.contactNumber">
                <span v-show="errors.has(validationName + 'contactNumber')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'contactNumber')" class="fas fa-exclamation-triangle"></i> {{ errors.first(validationName + 'contactNumber') }}
                </span>
              </div>
              <div class="control">
                <b-checkbox
                  :native-value="false"
                  name="chkWrongProfile"
                  type="is-info"
                  v-tooltip="'Is Wrong Profile'"
                  v-model="customerContactNumber.isWrongProfile">
                </b-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-loading :is-full-page="true" :active.sync="showLoader" :canCancel="false"></b-loading>
    </div>
    <confirm-delete-modal v-if="isDeleteConfirmationActive" title="Confirm Delete Contact Number" @on-confirm-delete="onRemoveContactNumber" @on-cancel-delete="isDeleteConfirmationActive = false">
      Are you sure you wish to delete the selected contact number?
    </confirm-delete-modal>
  </div>
</template>

<script>
import ConfirmDeleteModalComponent from '@/components/generic/ConfirmDeleteModalComponent'

import { createNamespacedHelpers } from 'vuex'
const mapConfigGetters = createNamespacedHelpers('config').mapGetters

export default {
  name: 'ContactNumberCapture',
  props: {
    value: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: 0
    },
    scope: {
      type: String,
      default: null
    },
    getValidationErrors: {
      type: Boolean,
      default: false
    },
    useValidator: {
      type: Object,
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    isUniqueNumber: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'confirm-delete-modal': ConfirmDeleteModalComponent
  },
  data () {
    return {
      instanceName: this.$uuid.v4(),
      showLoader: false,
      customerContactNumber: this.value,
      isDeleteConfirmationActive: false
    }
  },
  computed: {
    ...mapConfigGetters(['definedTypes']),
    validationName: function () {
      return (this.scope) ? this.scope + '.' + this.instanceName + '.' : this.instanceName + '.'
    }
  },
  methods: {
    onRemoveContactNumberConfirm: function () {
      this.isDeleteConfirmationActive = true
    },
    onRemoveContactNumber: function () {
      this.$emit('on-contact-number-remove', this.customerContactNumber)
    }
  },
  watch: {
    getValidationErrors: function (newValue, oldValue) {
      if (newValue === true) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.customerContactNumber.hasValidationErrors = false
            this.customerContactNumber.canSave = true
          } else {
            this.customerContactNumber.hasValidationErrors = true
            this.customerContactNumber.canSave = false
          }
        })
      }
    }
  },
  created: function () {
    if (this.useValidator) {
      this.$validator = this.useValidator
    } else {
      this.$validator = this.$parent.$validator
    }
  }
}
</script>

<style scoped>
</style>
